export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "print_report": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Print"])},
        "page_headers": {
          "report_header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Exam books inventory report"])},
          "location": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Location: "])},
          "date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Date: "])},
          "requested_by": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Requested by: "])}
        },
        "root": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Central Marking Centre"])},
        "table_headers": {
          "exams": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Exams"])},
          "control_numbers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Control number"])},
          "code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code"])},
          "version_number": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Version number"])},
          "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Description"])},
          "items_in_inventory": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Items in inventory"])},
          "received": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Received"])},
          "not_available": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Not<br/>available"])},
          "signed_out": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Signed out"])},
          "sent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sent"])},
          "removed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Removed"])},
          "recalled": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Recalled"])},
          "comments": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Comments"])}
        },
        "none": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["None"])},
        "no_data": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["There is currently no inventory at this location."])}
      },
      "fr": {
        "print_report": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "page_headers": {
          "report_header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rapport d’inventaire des cahiers d’examen"])},
          "location": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lieu :"])},
          "date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Date: "])},
          "requested_by": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Demandé par :"])}
        },
        "root": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Centre de correction centralisée des examens"])},
        "table_headers": {
          "exams": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Examens"])},
          "control_numbers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numéro de contrôle"])},
          "code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code"])},
          "version_number": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numéro de version"])},
          "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Description"])},
          "items_in_inventory": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Articles en inventaire"])},
          "received": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reçu"])},
          "not_available": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non<br/>disponible"])},
          "signed_out": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Déconnecté"])},
          "sent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Envoyé"])},
          "recalled": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rappelé"])},
          "comments": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Remarques"])}
        },
        "none": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      }
    }
  })
}